import axiosInstance from "./AxiosInstance";

// Fetch list of medicines with pagination
// export function getMedicines(pagination, pageid,search_by = "", search_keyword = "" ) {
//   return axiosInstance.post(
//     '/admin/medicineList',
//     { pagination, pageid,search_by,search_keyword}
    
//   );
// }
export function getMedicines(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("/admin/medicineList", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order
  });
}

// Create a new medicine
export function createMedicine(medicineData) {
  return axiosInstance.post("/admin/addMedicine", medicineData);
}

// Update an existing medicine
export function updateMedicine(medicineData) {
  return axiosInstance.post(`/admin/editMedicine`, {
    ...medicineData,
    medicine_id: medicineData.medicine_id,
  });
}

// Delete a medicine
export function deleteMedicine(medicine) {
  console.log("medicine:",medicine);
  return axiosInstance.post(`/admin/deleteMedicine`, medicine);
}

// Format medicines data for consistency
export function formatMedicines(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map(medicine => ({
      ...medicine,
      medicine_id: medicine.medicine_id || medicine._id || medicine.id,
    }));
  }

  let medicines = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      medicines.push({
        ...responseData[key],
        medicine_id: responseData[key].medicine_id || responseData[key]._id || responseData[key].id || key,
      });
    }
  }
  return medicines;
}
